import styled from 'styled-components';
import { theme } from '../../../theme';
import { Form } from 'react-bootstrap';

export const FormGroup = styled(Form.Group)`
  margin-bottom: 1.846rem;
  position: relative;

  svg {
    display: inline-block;
    vertical-align: initial;
    margin-left: 1rem;
  }

  input {
    width: 100%;
    min-height: 3rem;
    padding: 0 1.078rem;
    font-size: 0.923rem;
    line-height: 2.9rem;
    font-weight: 500;
    text-align: left;
    border-radius: 5px;
    border: 1px solid ${theme.colors.secondary};
    color: ${theme.colors.textPrimary};
    background-color: ${theme.colors.white};
    outline: none;

    &.number-format {
      width: 11.923rem;
    }

    &.form-control.is-invalid {
      border-color: ${theme.colors.error};
      background-image: none;
    }

    &::placeholder {
      color: ${theme.colors.secondary};
    }

    &:hover,
    &:active,
    &:focus {
      box-shadow: none !important;
      border: 1px solid ${theme.colors.secondary} !important;
      color: ${theme.colors.textPrimary} !important;
      background-color: ${theme.colors.white} !important;
    }
  }

  &.is-error input {
    border-color: ${theme.colors.error} !important;
  }

  &.filter-number-format {
    margin-top: 0.3rem;
    margin-right: 2rem;
    display: inline-block;

    label {
      font-size: 0.9rem;
      margin-bottom: 2px;
    }
    input {
      width: 5.5rem;
      height: 30px;
      min-height: unset;
      padding: 0.65rem;
      font-size: 0.8rem;
      border: 1px solid ${theme.colors.secondary};
    }
    div {
      line-height: 30px;
    }
  }

  &.append {
    margin-bottom: 0.615rem;

    input {
      border-radius: 5px 0 0 5px;
    }
  }

  .input-group-append span {
    border: none;
    cursor: pointer;
    background-color: unset;
    transition: background-color 0.3s ease;

    svg {
      margin: 0 1.538rem;
      color: ${theme.colors.textPrimary};
      transition: color 0.3s ease;
    }

    &:hover {
      background-color: ${theme.colors.error};

      svg {
        color: ${theme.colors.white};
      }
    }
  }
`;

export const Label = styled.label`
  margin-bottom: 0.615rem;
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.textPrimary};
`;

export const FormTextError = styled(Form.Text)`
  position: absolute;
  left: 0;
  margin-top: 0;
  font-size: 0.923rem;
  color: ${theme.colors.error};
`;

export const DivSuffix = styled.div<{ prefix?: number }>`
  margin-left: 0.615rem;
  display: inline-block;
  line-height: 3rem;
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.textPrimary};

  &.prefix {
    margin-left: 0;
    margin-right: 0.615rem;
  }
`;
